//Mutation Observer
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
waitForElm('.product-details-form-wrapper .ruk_rating_snippet[title]').then(() => {
    document.querySelector(".product-details-form-wrapper .ruk_rating_logo img").style.display = "block"; 
});

// listen for resultsLoadedEvent from the boost react search component
document.addEventListener('results_loaded', function (e) {
    console.log('Results Loaded Event', e.detail);
    const resultsText = e.detail.productSearchResult.products.length === 0 
        ? `No search results found for "${e.detail.searchTerms}"` 
        : `${e.detail.productSearchResult.products.length} search results for "${e.detail.searchTerms}"`;
    document.querySelector(".header.search-header h1").innerText = `${resultsText}`;
});
// Don't allow past dates to be picked from the calendar
document.addEventListener('DOMContentLoaded', function (e) {
    const subGiftDate = document.querySelector(".date-input");
    if(subGiftDate) {
        subGiftDate.min = new Date().toISOString().slice(0, 10);
    }
});
// Accordions on open on sub page
document.addEventListener('DOMContentLoaded', function (e) {
    var acc = document.querySelectorAll('.accordion');
    // Iterate to add event listeners
    acc.forEach(item => {
        item.addEventListener('click', function () {
            // When it's clicked, loop through all the items
            acc.forEach(el => {
                // Close any open items
                if (el.classList.contains('open')) {
                    el.classList.remove('open')
                    // If it's the one that was clicked and it's closed, open it
                } else if (el === item) {
                    el.classList.add('open')
                }
            });
        });
    });
});

//Mutation Observer for Gift Sub Flow FAQ Accordions
var ourObserver = new MutationObserver(function() {
var acc = document.querySelectorAll('.recharge-accordion');
// Iterate to add event listeners
acc.forEach(item => {
    item.addEventListener('click', function () {
        // When it's clicked, loop through all the items
        acc.forEach(el => {
            // Close any open items
            if (el.classList.contains('open')) {
                closeAcc(el);
                // If it's the one that was clicked and it's closed, open it
            } else if (el === item) {
                openAcc(el);
            }
        });
    });

});

function closeAcc (el) {
    el.classList.remove('open');
};

function openAcc (el) {
    el.classList.add('open');
}
});

ourObserver.observe(document.querySelector("body"), {
    subtree: true,
    childList: true
});

let intervalTime = 100;
let maxWaitTime = 10000;
let elapsedTime = 0;

const intervalId = setInterval(() => {
  const filterContainer = document.querySelectorAll('.sf-search-filter-container');
  const filterButton = document.querySelector('.filter-btn');

  if (filterContainer.length > 0) {
    clearInterval(intervalId);
    if (filterButton) {
      filterButton.classList.remove('hide');
    }
    console.log('Filter container found, hide class removed.');
  }

  elapsedTime += intervalTime;
  if (elapsedTime >= maxWaitTime) {
    clearInterval(intervalId);
    console.log('Max wait time reached, interval cleared.');
  }
}, intervalTime);

//SEO Block Truncate fix for HTML code
document.addEventListener('DOMContentLoaded', function (e) {
    var truncateButton = document.querySelectorAll('.cta-basic');
    truncateButton.forEach(item => {
        item.addEventListener('click', function () {
            document.querySelector("[data-text-content-short] > div").classList.toggle("hide")
            document.querySelector("[data-text-content-short] .read-more").classList.toggle("hide")
            document.querySelector("[data-text-content-long] > div").classList.toggle("hide")
            document.querySelector("[data-text-content-long] .read-less").classList.toggle("hide")
        });
    });
});